import { Component, Input } from "@angular/core";
import { DropdownComponent } from '../../dropdown/dropdown.component';
import { CommonModule } from "@angular/common";
import { Store } from "@ngrx/store";
import { LibOptionValue } from "daisy-design-system-front";
import { Observable } from "rxjs";
import { FormControl } from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {
  selectSubscriptionLoading,
  selectSubscriptionOptions
} from '../../../../store/subscriptions/subscriptions.selectors';

@Component({
  selector: "app-select-subscriptions",
  templateUrl: "./select-subscriptions.component.html",
  styleUrls: ["./select-subscriptions.component.scss"],
  standalone: true,
  imports: [CommonModule, DropdownComponent, TranslateModule],
})
export class SelectSubscriptionsComponent {
  @Input() valueFormControl = new FormControl<string[] | null>(null);

  public emptyFormControl = new FormControl([]);
  public subscriptionView$!: Observable<LibOptionValue<string>[]>;
  public loading$ : Observable<boolean>;

  constructor(private readonly store: Store) {
    this.subscriptionView$ = this.store.select(selectSubscriptionOptions);
    this.loading$ = this.store.select(selectSubscriptionLoading);
  }
}
